import { Component, Inject, OnInit, OnDestroy, Injectable } from '@angular/core';
import { DwAction, DwActionType, DwButtonType, DwActionHandler, DwMdFormActionState,
         DwActionResult, DwConfigServiceToken, DwConfigService } from '@devwareapps/devware-cap';
import { AdminManagerService } from '../../../features/admin/services/admin-manager.service';
import { AppMetaDataItemNames, InvoiceEntity, ProcessorConfigEntity } from '../../../meta-data/app-meta-data.service';
import { Observable, of } from "rxjs";
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { map, mergeMap } from 'rxjs/operators';
import { AviatorUser } from '../../shared/models/aviator-user.model';

@DwAction({
    keyName: 'refundInvoice',
    display: 'Refund Invoice',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [AppMetaDataItemNames.Invoice],
    actionMessage: 'Processing Refund...',
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Refund Invoice',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-sack-dollar',
    },
    defaultConfirmConfig : {
        showDialogConfig: true,
        showConfirmDialog: true,
        title: 'Confirm Invoice Refund',
        message: 'Are you sure you want to refund this invoice? This action cannot be undone.'
    }
})
@Injectable()
export class ReundInvoiceActionService implements DwActionHandler {
    
    constructor(
        private paymentsRepoSvc: PaymentsRepositoryService)
    { 
        
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const invoice = actionState.formApi.getFormData<InvoiceEntity>();

        return this.paymentsRepoSvc.refundInvoice({
            invoiceId: invoice.InvoiceId
        }).pipe(map(refundResult => {
            const result: DwActionResult = {
                success: refundResult.Success,
                message: refundResult.Message
            };

            if (refundResult.Success) {
                refundResult.Message = "Refund processed successfully.";

                actionState.formApi.loadData(true)
                    .subscribe(data => {
                        console.log(data);
                    });
            }
            return result;
        }));
    }
}
  